import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint arrow-parens: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// Components
import Filter from './Filter';

// Utils
import findAndReplace from '../../../utils/findAndReplace';

// Helpers
import { getFilterData } from './filtersList.helpers';

// Styles
import s from './filtersList.module.scss';
var REPLACEMENT_OPTIONS = {
  addIfNotPresent: true
};
var FiltersList = /*#__PURE__*/function (_Component) {
  _inherits(FiltersList, _Component);
  var _super = _createSuper(FiltersList);
  function FiltersList() {
    var _this;
    _classCallCheck(this, FiltersList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      var _this$props = _this.props,
        selectedFilters = _this$props.selectedFilters,
        onFilterApply = _this$props.onFilterApply,
        saveDefaultFilters = _this$props.saveDefaultFilters;
      var updatedSelectedFilters = findAndReplace({
        type: filter.type
      }, filter, selectedFilters, REPLACEMENT_OPTIONS);
      saveDefaultFilters(updatedSelectedFilters);
      onFilterApply(updatedSelectedFilters);
    });
    _defineProperty(_assertThisInitialized(_this), "renderFilterType", function (filterType) {
      var _this$props2 = _this.props,
        selectedFilters = _this$props2.selectedFilters,
        isFilterLabelStacked = _this$props2.isFilterLabelStacked,
        filterContainerClassname = _this$props2.filterContainerClassname;
      var _getFilterData = getFilterData(selectedFilters, filterType),
        values = _getFilterData.values,
        additional = _getFilterData.additional;
      return /*#__PURE__*/React.createElement(Filter, {
        filterType: filterType,
        onChange: _this.handleChange,
        values: values,
        additional: additional,
        isFilterLabelStacked: isFilterLabelStacked,
        containerClassname: filterContainerClassname
      });
    });
    return _this;
  }
  _createClass(FiltersList, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        filterTypes = _this$props3.filterTypes,
        showFilterTrigger = _this$props3.showFilterTrigger;
      var className = showFilterTrigger ? s.container : s.containerWithoutTrigger;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex ".concat(className)
      }, _map(filterTypes, this.renderFilterType));
    }
  }]);
  return FiltersList;
}(Component);
FiltersList.propTypes = {
  filterTypes: PropTypes.array.isRequired,
  selectedFilters: PropTypes.array,
  onFilterApply: PropTypes.func,
  saveDefaultFilters: PropTypes.func,
  isFilterLabelStacked: PropTypes.bool,
  filterContainerClassname: PropTypes.string
};
FiltersList.defaultProps = {
  selectedFilters: EMPTY_ARRAY,
  onFilterApply: _noop,
  saveDefaultFilters: _noop,
  isFilterLabelStacked: false,
  filterContainerClassname: EMPTY_STRING
};
export default FiltersList;